module.exports = __webpack_public_path__ + "img/normal_interest_info.65422e42.png";